export const FETCH_REPORT_DETAILS = "dashboard/FETCH_REPORT_DETAILS";
export const SET_INSIGHTS_COUNTRY_COSTCENTER =
	"dashboard/SET_INSIGHTS_COUNTRY_COSTCENTER";
//export const DRIVER_PROFILE = "dashboard/driverProfile";
export const PROFILE_NOTES = "dashboard/profileNotes";
export const FETCH_CARD_DETAILS = "dashboard/FETCH_CARD_DETAILS";
export const ADD_NOTES = "dashboard/addNotes";
export const DASHBOARD_PROFILE = "dashboard/profile";
export const SET_VEHICLE_HISTORY = "dashboard/SET_VEHICLE_HISTORY";
export const FETCH_VEHICLE_HISTORY = "dashboard/FETCH_VEHICLE_HISTORY";
export const SET_BOOKMARK = "dashboard/SET_BOOKMARK";
export const SET_SIDE_PANEL = "dashboard/SET_SIDE_PANEL";

export type Action =
	| { type: FETCH_REPORT_DETAILS, data: Object }
	| { type: FETCH_CARD_DETAILS, data: Object }
	| { type: SET_INSIGHTS_COUNTRY_COSTCENTER, data: Object }
	| { type: FETCH_CARD_SUMMARY, data: Object }
	| { type: DASHBOARD_PROFILE }
	| { type: ADD_NOTES }
	| { type: SET_VEHICLE_HISTORY }
	| { type: FETCH_VEHICLE_HISTORY }
	| { type: SET_BOOKMARK }
	| { type: SET_SIDE_PANEL }
	| { type: PROFILE_NOTES };



// WEBPACK FOOTER //
// ./src/features/dashboard/actions/action-types.js